/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MedicineItemDto } from './MedicineItemDto';
import {
    MedicineItemDtoFromJSON,
    MedicineItemDtoFromJSONTyped,
    MedicineItemDtoToJSON,
    MedicineItemDtoToJSONTyped,
} from './MedicineItemDto';

/**
 * 
 * @export
 * @interface AddMedicinesToPrescriptionOrderRequestDto
 */
export interface AddMedicinesToPrescriptionOrderRequestDto {
    /**
     * Array of medicines to add to the prescription order
     * @type {Array<MedicineItemDto>}
     * @memberof AddMedicinesToPrescriptionOrderRequestDto
     */
    medicines: Array<MedicineItemDto>;
}

/**
 * Check if a given object implements the AddMedicinesToPrescriptionOrderRequestDto interface.
 */
export function instanceOfAddMedicinesToPrescriptionOrderRequestDto(value: object): value is AddMedicinesToPrescriptionOrderRequestDto {
    if (!('medicines' in value) || value['medicines'] === undefined) return false;
    return true;
}

export function AddMedicinesToPrescriptionOrderRequestDtoFromJSON(json: any): AddMedicinesToPrescriptionOrderRequestDto {
    return AddMedicinesToPrescriptionOrderRequestDtoFromJSONTyped(json, false);
}

export function AddMedicinesToPrescriptionOrderRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddMedicinesToPrescriptionOrderRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'medicines': ((json['medicines'] as Array<any>).map(MedicineItemDtoFromJSON)),
    };
}

export function AddMedicinesToPrescriptionOrderRequestDtoToJSON(json: any): AddMedicinesToPrescriptionOrderRequestDto {
    return AddMedicinesToPrescriptionOrderRequestDtoToJSONTyped(json, false);
}

export function AddMedicinesToPrescriptionOrderRequestDtoToJSONTyped(value?: AddMedicinesToPrescriptionOrderRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'medicines': ((value['medicines'] as Array<any>).map(MedicineItemDtoToJSON)),
    };
}

